<template>
  <van-checkbox-group
    v-model="checkValue"
    direction="horizontal"
    class="aj-checkbox"
    :class="wrap ? '' : 'aj-checkbox-nowrap'"
    :style="{
      '--bgColor': bgColor,
      '--textColor': textColor,
      '--bgColorActive': bgColorActive,
      '--textColorActive': textColorActive
    }"
  >
    <van-checkbox v-for="item in checkList" :key="item[props.value]" :name="item[props.value]">{{ item[props.label] }}</van-checkbox>
  </van-checkbox-group>
</template>

<script>
export default {
  props: {
    optionList: {
      type: Array,
      default: () => []
    },

    props: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        };
      }
    },
    value: {
      type: Array,
      default: () => []
    },
    hasAll: {
      type: String,
      default: null
    },
    wrap: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String,
      default: 'rgb(224,232,246)'
    },
    textColor: {
      type: String,
      default: '#333'
    },
    bgColorActive: {
      type: String,
      default: '#3775ff'
    },
    textColorActive: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {};
  },
  computed: {
    checkValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (this.hasAll) {
          if (newValue.length == 0) {
            this.$emit('input', [this.hasAll]);
            this.$emit('change', [this.hasAll]);
          } else {
            if (this.value.indexOf(this.hasAll) == -1 && newValue.indexOf(this.hasAll) != -1) {
              this.$emit('input', [this.hasAll]);
              this.$emit('change', [this.hasAll]);
            } else if (this.value.indexOf(this.hasAll) != -1 && newValue.indexOf(this.hasAll) != -1) {
              const tempList = JSON.parse(JSON.stringify(newValue));
              tempList.splice(tempList.indexOf(this.hasAll), 1);
              this.$emit('input', tempList);
              this.$emit('change', tempList);
            } else {
              this.$emit('input', newValue);
              this.$emit('change', newValue);
            }
          }
        } else {
          this.$emit('input', newValue);
          this.$emit('change', newValue);
        }
      }
    },
    checkList: {
      get() {
        if (this.hasAll) {
          let obj = {};
          obj[this.props.label] = '全部';
          obj[this.props.value] = this.hasAll ? this.hasAll : 'all';
          let list = JSON.parse(JSON.stringify(this.optionList));
          list.unshift(obj);
          return list;
        } else {
          return this.optionList;
        }
      }
    }
  },
  methods: {
    changeRadio(data) {}
  }
};
</script>

<style lang="scss" scoped>
.aj-checkbox {
  &.aj-checkbox-nowrap::v-deep.van-checkbox-group--horizontal {
    flex-wrap: nowrap;
    .van-checkbox {
      margin-bottom: 0rem;
    }
  }
  ::v-deep.van-checkbox {
    flex-shrink: 0;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;
    .van-checkbox__icon {
      display: none;
    }
    .van-checkbox__label {
      margin-left: 0;
      line-height: none;
      padding: 0.3rem 1rem;
      border-radius: 0.9rem;
      font-size: 0.8rem;
      line-height: normal;
    }
    &[aria-checked='true'] {
      .van-checkbox__label {
        background-color: var(--bgColorActive);
        color: var(--textColorActive);
      }
    }
    &[aria-checked='false'] {
      .van-checkbox__label {
        background-color: var(--bgColor);
        color: var(--textColor);
      }
    }
  }
}
</style>
